import _Object$getPrototypeOf from 'babel-runtime/core-js/object/get-prototype-of';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';
import React, { PureComponent } from 'react';
import GlobalItem from './GlobalItem';
import DrawerTrigger from './DrawerTrigger';
import GlobalPrimaryActionsList from './GlobalPrimaryActionsList';
import GlobalPrimaryActionsInner from '../styled/GlobalPrimaryActionsInner';
import GlobalPrimaryActionsPrimaryItem from '../styled/GlobalPrimaryActionsPrimaryItem';
import GlobalPrimaryActionsItemsWrapper from '../styled/GlobalPrimaryActionsItemsWrapper';

var GlobalPrimaryActions = function (_PureComponent) {
  _inherits(GlobalPrimaryActions, _PureComponent);

  function GlobalPrimaryActions() {
    _classCallCheck(this, GlobalPrimaryActions);

    return _possibleConstructorReturn(this, (GlobalPrimaryActions.__proto__ || _Object$getPrototypeOf(GlobalPrimaryActions)).apply(this, arguments));
  }

  _createClass(GlobalPrimaryActions, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          actions = _props.actions,
          createIcon = _props.createIcon,
          linkComponent = _props.linkComponent,
          onCreateActivate = _props.onCreateActivate,
          onSearchActivate = _props.onSearchActivate,
          primaryIcon = _props.primaryIcon,
          primaryIconAppearance = _props.primaryIconAppearance,
          primaryItemHref = _props.primaryItemHref,
          searchIcon = _props.searchIcon;

      return React.createElement(
        GlobalPrimaryActionsInner,
        null,
        primaryIcon ? React.createElement(
          GlobalPrimaryActionsPrimaryItem,
          null,
          React.createElement(
            GlobalItem,
            {
              href: primaryItemHref,
              linkComponent: linkComponent,
              size: 'medium',
              appearance: primaryIconAppearance
            },
            primaryIcon
          )
        ) : null,
        React.createElement(
          GlobalPrimaryActionsItemsWrapper,
          null,
          actions ? React.createElement(GlobalPrimaryActionsList, { actions: actions }) : React.createElement(
            'div',
            null,
            searchIcon ? React.createElement(
              DrawerTrigger,
              { onActivate: onSearchActivate },
              searchIcon
            ) : null,
            createIcon ? React.createElement(
              DrawerTrigger,
              { onActivate: onCreateActivate },
              createIcon
            ) : null
          )
        )
      );
    }
  }]);

  return GlobalPrimaryActions;
}(PureComponent);

export default GlobalPrimaryActions;